import { render, staticRenderFns } from "./MergeList.vue?vue&type=template&id=3b76a299&scoped=true&"
import script from "./MergeList.vue?vue&type=script&lang=js&"
export * from "./MergeList.vue?vue&type=script&lang=js&"
import style0 from "./MergeList.vue?vue&type=style&index=0&id=3b76a299&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b76a299",
  null
  
)

export default component.exports